var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck2Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9476 8.62169L11.5943 16.6834L9.37763 14.315C8.9693 13.93 8.32763 13.9067 7.86096 14.2334C7.40596 14.5717 7.27763 15.1667 7.55763 15.645L10.1826 19.915C10.4393 20.3117 10.8826 20.5567 11.3843 20.5567C11.8626 20.5567 12.3176 20.3117 12.5743 19.915C12.9943 19.3667 21.0093 9.81169 21.0093 9.81169C22.0593 8.73836 20.7876 7.79336 19.9476 8.61002V8.62169Z",
    fill: "#9E77ED"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2Svg);
export default __webpack_public_path__ + "static/media/Check2Svg.b4ad43a362f23df8e84129b2ed8629ef.svg";
export { ForwardRef as ReactComponent };